/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment-timezone');

if (__CLIENT__) {
	require('../../../node_modules/waypoints/lib/jquery.waypoints');
}

var Header = (function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, _Header);

		_Component.apply(this, arguments);

		this.state = {
			timestamp: _moment2['default']().tz('America/New_York').format('dddd, MMMM Do, YYYY'),
			simpleHeader: false,
			isStuck: false
		};
	}

	Header.prototype.componentDidMount = function componentDidMount() {
		var _this = this;
		var masthead = _reactDom2['default'].findDOMNode(this.refs.masthead);

		/**
   * Fire up Waypoints Sticky
   */
		/* eslint no-new: 0 */
		/* eslint no-undef: 0 */
		new Waypoint({
			element: masthead,
			handler: function handler(direction) {
				_this.setState({
					isStuck: direction === 'down'
				});
			}
		});

		/**
   * Enquire
   * Use to trigger “mobile” state.
   */
		var enquire = require('../../../static/js/enquire');
		enquire.register('(min-width:0px) and (max-width:' + _srcSettings2['default'].media.small + ')', {
			match: function match() {
				_this.setState({ simpleHeader: true });
			},
			unmatch: function unmatch() {
				_this.setState({ simpleHeader: false });
			}
		});
	};

	Header.prototype.render = function render() {
		var _classNames;

		var styles = require('./Masthead.css');

		var isSmallViewport = this.props.isSmallViewport;

		var mastheadStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = !this.state.simpleHeader, _classNames[styles['Base--simple']] = this.state.simpleHeader, _classNames['Masthead--isStuck'] = this.state.isStuck, _classNames));

		return _react2['default'].createElement(
			'section',
			{ className: mastheadStyles, ref: 'masthead' },
			_react2['default'].createElement(
				'header',
				{ className: styles.Header },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Masthead, to: '/' },
					_react2['default'].createElement(
						'span',
						{ className: styles.Logo },
						'Home | BaltimoreBrew.com'
					)
				),
				this.state.simpleHeader && _react2['default'].createElement(_components.FullMenu, { className: styles.FullMenu }),
				!this.state.simpleHeader && _react2['default'].createElement(_components.Navigation, { className: styles.Nav, selected: this.props.selected, links: this.props.links }),
				!isSmallViewport && !this.state.isStuck && _react2['default'].createElement(
					'div',
					{ className: styles.TimeStamp },
					_react2['default'].createElement(
						'time',
						null,
						this.state.timestamp
					)
				)
			)
		);
	};

	_createClass(Header, null, [{
		key: 'propTypes',
		value: {
			isSmallViewport: _react.PropTypes.bool,
			links: _react.PropTypes.array,
			selected: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _Header = Header;
	Header = _reactRedux.connect(function (state) {
		return {
			isSmallViewport: state.responsive.isSmallViewport
		};
	})(Header) || Header;
	return Header;
})(_react.Component);

exports['default'] = Header;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Masthead/Masthead.js
 ** module id = 682
 ** module chunks = 0
 **/